import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-assign-instructor-support-article',
    template: `
        <ng-container i18n="@@support.articles.assignInstructor">
            <p>An instructor can be assigned to one or more classes. An instructor assigned to a class can monitor the students of that class. If desired, a class can also be monitored by different instructors.</p>

            <h2>Assign by class</h2>
            <p>When you create a new class, you can immediately select the desired instructor(s). When editing a class, you can still change the assigned instructors.</p>
            <p>
                <a
                    routerLink="/support/organizations/classes/add"
                    mat-stroked-button
                    color="primary"
                    class="supportLink"
                >Add a class</a>
                <a
                    routerLink="/support/organizations/classes/edit"
                    mat-stroked-button
                    color="primary"
                    class="supportLink"
                >Edit a class</a>
            </p>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/editClass.png" />
                <figcaption>Check the desired instructors in the list.</figcaption>
            </figure>

            <h2>Assign multiple classes</h2>
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/instructors">Instructors Overview</a>.</span>
                </li>
                <li>
                    <span>Find the instructor in the list or use the search field to find the instructor.</span>
                </li>
                <li>
                    <span>Click on the instructor's name.</span>
                </li>
                <li>
                    <div>
                        <p>At the bottom of the page you can see which classes this instructor is already assigned to.</p>
                        <p>Click the <strong>Assign classes</strong> button.</p>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/assignInstructorClassesBtn.png" />
                        </p>
                    </div>
                </li>
                <li>
                    <div>
                        <p><strong>Select the desired classes</strong> in the window that opens.</p>
                        <p>Is the class not listed yet? Click on <em>Add class</em> to add the class first.</p>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/assignInstructorClasses.png" />
                        </p>
                    </div>
                </li>
                <li>
                    <span>Click <strong>Save</strong>. The instructor is now able to monitor the selected classes.</span>
                </li>
            </ol>
        </ng-container>
    `
})
export class AssignInstructorSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
